import ExperimentsManager, { ExperimentsProps as ExperimentsManagerOptions } from '@wix/wix-experiments';
import { SupportedLanguage } from './data/languages';

export type Experiments = {
  'specs.funnel.AddEcommerceToWixHeader': 'A' | 'B';
  'specs.funnel.WixHeaderStartForFreeButtonInLangs': 'A' | 'B';
  'specs.funnel.MoveTemplatesLinkToTop': 'A' | 'B';
};

export const experimentFallbacks: Experiments = {
  'specs.funnel.AddEcommerceToWixHeader': 'A',
  'specs.funnel.WixHeaderStartForFreeButtonInLangs': 'A',
  'specs.funnel.MoveTemplatesLinkToTop': 'A',
};

export const loadExperiments = async (language: SupportedLanguage): Promise<Experiments> => {
  const experimentsManager = createExperimentManager();

  if (['ja', 'fr', 'de', 'pt'].includes(language)) {
    conduct(experimentsManager, 'specs.funnel.WixHeaderStartForFreeButtonInLangs');
  }

  if (language === 'en') {
    conduct(experimentsManager, 'specs.funnel.AddEcommerceToWixHeader');
    conduct(experimentsManager, 'specs.funnel.MoveTemplatesLinkToTop');
  }

  return experimentsManager.ready().then(() => ({ ...experimentFallbacks, ...experimentsManager.all() }));
};

const conduct = (experimentsManager: ExperimentsManager, spec: keyof Experiments) => {
  experimentsManager.conduct(spec, experimentFallbacks[spec]);
};

const createExperimentManager = (optionsOverrides: ExperimentsManagerOptions = {}): ExperimentsManager => {
  const defaultOptions: ExperimentsManagerOptions =
    window.location.origin === 'https://status.wix.com'
      ? { baseUrl: 'https://manage.wix.com' }
      : { useNewApi: window.WIX_HF_DEBUG };

  return new ExperimentsManager({ ...defaultOptions, ...optionsOverrides });
};
